import { FormattedMessage } from "react-intl"

const Input = (props) => {
  return (
    <div className="col-xs-4">
      <label>
        <FormattedMessage id={`togo.measurement_labels.${props.type}.title`} />
        <span className="label-red">*</span>
        <br />
        <input
          name={props.type}
          value={props.value}
          type="number"
          step=".001"
          min="1"
          placeholder="0"
          onChange={props.handleChange}
          onBlur={e => (e.target.placeholder = "0")}
          onFocus={props.handleInputFocus}
          required
        />
        <div className=".invalid-feedback" style={props.errorStyle} />
      </label>
    </div>
  )
}

const MeasurementInputs = (props) => {
  const { width, length, height } = props

  return (
    <div className="form-row row">
      <Input type="width" value={width} {...props} />
      <Input type="length" value={length} {...props} />
      <Input type="height" value={height} {...props} />
    </div>

  )
}

export default MeasurementInputs
